import { AgGridReact, AgGridReactProps } from 'ag-grid-react';
import React, { FunctionComponent, useEffect, useRef } from 'react';

import { useDebouncedWindowSize } from '../../../hooks/useDebouncedWindowSize';

import { AgGridTableContainer } from './AgGridTableContainer/AgGridTableContainer';

export interface AgGridProps extends AgGridReactProps {}

const AgGridDefaultProps = {};

export const AgGridTable: FunctionComponent<AgGridProps> = props => {
  // const gridPropsRef = useRef<AgGrid.ColumnApi>(null);
  const gridPropsRef = useRef<any>(null);
  const { width, height } = useDebouncedWindowSize(100);

  useEffect(() => {
    if (gridPropsRef.current) {
      gridPropsRef.current.api.sizeColumnsToFit();
    }
  }, [width, height, props.rowData, props.columnDefs]);

  return (
    <AgGridTableContainer>
      <AgGridReact
        domLayout="autoHeight"
        defaultColDef={{ resizable: true }}
        rowHeight={30}
        {...props}
        onGridReady={gridProps => {
          gridPropsRef.current = gridProps;
          setTimeout(() => {
            gridPropsRef.current.api.sizeColumnsToFit();
          }, 100);
          if (props.onGridReady) {
            props.onGridReady(gridProps);
          }
        }}
        onFirstDataRendered={params => {
          setTimeout(() => {
            params.api.sizeColumnsToFit();
          }, 100);
          if (props.onFirstDataRendered) {
            props.onFirstDataRendered(params);
          }
        }}
      />
    </AgGridTableContainer>
  );
};

AgGridTable.defaultProps = AgGridDefaultProps;
